import { render, staticRenderFns } from "./TeamAvatar.vue?vue&type=template&id=1f699dc0"
import script from "./TeamAvatar.vue?vue&type=script&lang=js"
export * from "./TeamAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports